<template>
  <div id="app">
    <router-view v-if="info" />
    <div v-if="isIE" style="text-align: center; line-height: 400px;">
      IE浏览器下暂不提供支持，请使用谷歌或火狐浏览器。
    </div>
  </div>
</template>

<script>
import { setDefaultWebInfo } from '@/utils/common';
export default {
  name: 'App',
  data() {
    return {
      isIE: false,
      info: null
    };
  },
  created() {
    document.body.removeChild(document.getElementById('Loading'));
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      this.isIE = true;
      return false;
    } else if (this.$route.name != '500') {
      this.GetPlatformInfo();
    } else {
      this.info = {};
    }
  },
  methods: {
    GetPlatformInfo() {
      this.$store
        .dispatch('GetPlatformInfo')
        .then((res) => {
          this.info = res;
          // setDefaultWebInfo(res.siteTile, res.siteDesc, res.siteKeywords)
          setDefaultWebInfo();
        })
        .catch((err) => {
          if (err) {
            window.location = '/500';
          }
        });
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue